import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type {
  AcademicStructureTemplate,
  AcademicStructureTemplateListRow,
  CreateTemplatePayload,
  UpdateTemplatePayload,
  TemplateStructure,
  AddNodePayload,
  TemplateNode,
  Pagination,
} from "../types";

interface ListParams {
  status?: string;
  institutionType?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const fetchTemplates = async (
  params: ListParams = {}
): Promise<{ templates: AcademicStructureTemplateListRow[]; pagination: Pagination }> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.LIST, { params });
  return data;
};

export const createTemplate = async (payload: CreateTemplatePayload): Promise<AcademicStructureTemplate> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.CREATE, payload);
  return data.template;
};

export const updateTemplate = async (id: number, payload: UpdateTemplatePayload): Promise<AcademicStructureTemplate> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.UPDATE(id), payload);
  return data.template;
};

export const deleteTemplate = async (id: number): Promise<void> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.DELETE(id));
};

export const fetchTemplateStructure = async (id: number): Promise<TemplateStructure> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.STRUCTURE(id));
  return data;
};

export const addTemplateNode = async (templateId: number, payload: AddNodePayload): Promise<TemplateNode> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.NODES(templateId), payload);
  return data.node;
};

export const updateTemplateNode = async (
  templateId: number,
  nodeId: number,
  payload: Partial<AddNodePayload>
): Promise<TemplateNode> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.NODE(templateId, nodeId), payload);
  return data.node;
};

export const removeTemplateNode = async (templateId: number, nodeId: number): Promise<void> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.ACADEMIC_STRUCTURE_TEMPLATES.NODE(templateId, nodeId));
};
